let annoucement = localStorage.getItem('hide_annoucement');
/* console.log(annoucement); */
if (annoucement === null) {
    $('.annoucement').slideDown({
        start: function () {
            $(this).css({
                display: "flex"
            });
            $('header, .category-nav').addClass('has-announcement');
        }
    });
}

$(document).on("click", ".annoucement-close", function () {
    localStorage.setItem('hide_annoucement', true);
    $('.annoucement').hide();
    $('header, .category-nav').removeClass('has-announcement');
});